import { render } from "./ReceiptForce.vue?vue&type=template&id=d515c5d6&scoped=true"
import script from "./ReceiptForce.vue?vue&type=script&lang=js"
export * from "./ReceiptForce.vue?vue&type=script&lang=js"

import "./ReceiptForce.vue?vue&type=style&index=0&id=d515c5d6&scoped=true&lang=css"

import exportComponent from "E:\\workBase\\Vue\\hans-amdin-mobiles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d515c5d6"]])

export default __exports__